import { htmlEscape as h } from "../utils.js";

export function openDocumentPanel({ title, url }) {
  openPanel({
    title,
    content: `<iframe src="${url}" width="100%" height="100%"></iframe>`,
  });
}

export function openImagePanel({ title, url }) {
  openPanel({ title, content: `<img src="${url}" alt="${h(title)}"/>` });
}

export function openPanel({ title, content }) {
  const options = {
    headerTitle: title,
    headerControls: {
      add: {
        html: "<span class='fa fa-print'></span>",
        name: "print",
        position: 1,
        handler: function (panel) {
          panel.content.querySelector("iframe").contentWindow.print();
        },
      },
      smallify: "remove",
      maximize: "remove",
      size: "lg",
    },
    theme: "bootstrap-info",
    closeOnEscape: true,
    contentSize: "660px 60%",
    position: { my: "right-top", at: "right-top", autoposition: "left" },
    dragit: { containment: [0] },
    contentOverflow: "hidden auto",
    content,
  };

  window.top.jsPanel.create(options);
}
